import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { buttonVariants } from "@/components/ui/button-variants";
import { cn } from "@/lib/utils";

interface RenewalShareActionsProps {
  message: string;
  onDone: () => void;
  doneLabel?: string;
  isDoneDisabled?: boolean;
}

export function RenewalShareActions({
  message,
  onDone,
  doneLabel = "Already told them",
  isDoneDisabled = false,
}: RenewalShareActionsProps) {
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(message);
      toast.success("Reminder copied. Paste it to whoever handles billing.");
    } catch {
      toast.error("Couldn't copy the message. Please try again.");
    }
  };

  return (
    <div className="space-y-2">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(buttonVariants({ size: "lg" }), "w-full font-semibold")}
      >
        <MessageCircle />
        Send on WhatsApp
      </a>
      <div className="grid grid-cols-2 gap-2">
        <Button variant="outline" onClick={handleCopy}>
          Copy message
        </Button>
        <Button variant="outline" onClick={onDone} disabled={isDoneDisabled}>
          {doneLabel}
        </Button>
      </div>
    </div>
  );
}
